import React, { useContext, useEffect, useState } from 'react';
import {
	ApButtonMain,
	ApRadio,
	ApButtonDanger,
} from '@alixpartners/ui-components';
import {
	DropZoneWrapper,
	FileCountContainer,
	StepCount,
	FileNameContainer,
	ButtonWrapper,
	ErrorMessage,
	RadioContainer,
	RadioLabel,
	RadioHeader,
	Required,
	HeaderContainer,
	FilesWrapper,
	FilesContainer,
	NoteWrapper,
	DropWrapper,
} from './UploadFile.styles';
import Dropzone from 'react-dropzone';
import { GenerateSpendCubeContext } from 'contexts/GenerateSpendCubeContext';
import Instructions from '../Instructions/Instructions';
import { UploadInstructions } from 'Data/constants';

const radioOptions = [
	{
		dataType: 0,
		label: 'Direct',
	},
	{
		dataType: 1,
		label: 'Indirect',
	},
	{
		dataType: 2,
		label: 'Indirect / Mixed',
	},
];

const UploadFile = ({ setCurrentLoadingMessage }) => {
	const context = useContext(GenerateSpendCubeContext);
	const { onUploadClicked } = context;
	const [fileInfo, setFileInfo] = useState([{}]);
	const [infoComplete, setInfoComplete] = useState(false);
	const [fileError, setFileError] = useState([]);
	const [type, setType] = useState(null);

	useEffect(
		() => {
			for (const key in fileInfo) {
				Object.keys(fileInfo[key])?.length === 2
					? setInfoComplete(true)
					: setInfoComplete(false);
			}
		},
		[fileInfo]
	);

	useEffect(() => {
		setCurrentLoadingMessage({
			message: 'File upload in progress',
			text: 'Please stay on the application until all files are uploaded.',
		}); //eslint-disable-next-line
	}, []);

	const onFileSelected = (files, index) => {
		if (
			files[0] &&
			(files[0]?.type === 'text/csv' ||
				files[0]?.type ===
					'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
		) {
			const newArr = fileError;
			newArr[index] = false;
			setFileError(newArr);

			const updatedFileInfo = [...fileInfo];
			updatedFileInfo[index] = {
				...updatedFileInfo[index],
				file: files,
				selectedFileName: files[0].name,
			};
			setFileInfo(updatedFileInfo);
		} else {
			const newArr = fileError;
			newArr[index] = true;
			setFileError(newArr);
			const updatedFileInfo = [...fileInfo];
			updatedFileInfo[index] = {};
			setFileInfo(updatedFileInfo);
		}
	};

	const addFile = () => {
		setFileInfo(prevState => [...prevState, {}]);
	};

	const files = index => {
		return fileError[index] ? (
			<ErrorMessage>Please enter .csv or .xlsx files only</ErrorMessage>
		) : (
			<FileNameContainer>{fileInfo[index]?.selectedFileName}</FileNameContainer>
		);
	};

	const onDeleteClick = index => {
		const deletedFiles = [...fileInfo];
		deletedFiles.splice(index, 1);
		setFileInfo(deletedFiles);
	};

	return (
		<React.Fragment>
			<HeaderContainer>
				<StepCount>Step 1: File Upload</StepCount>
			</HeaderContainer>
			<Instructions
				headerText="File Upload Instructions"
				instructions={UploadInstructions}
			/>
			<RadioContainer>
				<RadioHeader>
					Please select the type of data<Required>*</Required>
				</RadioHeader>
				{radioOptions.map(option => {
					const { label, dataType } = option;
					return (
						<div key={dataType}>
							<ApRadio
								name={label}
								onChange={() => setType(dataType)}
								checked={type === dataType}
							>
								<RadioLabel>{label}</RadioLabel>
							</ApRadio>
						</div>
					);
				})}
			</RadioContainer>

			<DropWrapper>
				{fileInfo?.map((info, index) => (
					<FilesContainer key={index}>
						<DropZoneWrapper>
							<FilesWrapper>
								<FileCountContainer>{index + 1}.</FileCountContainer>
								<Dropzone
									accept=".csv, .xlsx"
									onDrop={file => onFileSelected(file, index)}
									noKeyboard
								>
									{({ getRootProps, getInputProps }) => (
										<div {...getRootProps()}>
											<input {...getInputProps()} />
											<ApButtonMain>Choose File</ApButtonMain>
										</div>
									)}
								</Dropzone>

								{files(index)}
							</FilesWrapper>

							<ApButtonDanger
								iconName="remove"
								onClick={() => {
									onDeleteClick(index);
								}}
							>
								Remove
							</ApButtonDanger>
						</DropZoneWrapper>
					</FilesContainer>
				))}
			</DropWrapper>

			<NoteWrapper>
				Please remove any entries with no file selected before proceeding with
				the upload.
			</NoteWrapper>
			<ButtonWrapper>
				<ApButtonMain iconName="baseline_add" onClick={addFile}>
					Add File
				</ApButtonMain>
				<ApButtonMain
					disabled={!infoComplete || type === null || fileInfo.length === 0}
					onClick={() => onUploadClicked(fileInfo, type)}
				>
					Upload
				</ApButtonMain>
			</ButtonWrapper>
		</React.Fragment>
	);
};

export default UploadFile;
